export const EVENT_TYPE: Record<string, string> = {
  order: 'Aceleração de pedido',
  'financing-pre-approved': 'Financiamento pré aprovado',
  'financing-approved': 'Financiamento aprovado.',
  'financing-customer-request': 'Cliente final solicitou financiamento',
  solleads: 'Visualização de SolLeads disponíveis',
}
